import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, AfterViewInit, ElementRef, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ValidateFormFieldsUtils } from "src/app/utils";

@Component({
    selector: "app-rx-select",
    templateUrl: "./rx-select.component.html",
    styles: [],
    standalone: false
})
export class RxSelectComponent implements OnInit, AfterViewInit {
    hasFGInvalid: boolean;
    autoFocus: boolean;
    
    @ViewChild('rxNgSelect', { static: false }) rxNgSelect: any;
    @Input()
    set LabelText(lt: string) {
        this.labelText = lt;
    }

    @Input()
    set FormGroupName(fg: FormGroup) {
        this.inputFormGroup = fg;
    }

    @Input()
    set ControlName(cn: string) {
        this.custContrlName = cn;
    }

    @Input()
    set PlaceHolder(ph: string) {
        this.placeHolder = ph;
    }

    @Input()
    set InputErrors(ie: any) {
        this.inputErrors = ie;
    }

    @Input()
    set ErrorDefs(ed: object) {
        this.errorDefs = ed;
    }

    @Input()
    set IsDisabled(ir: boolean) {
        this.isDisabled = ir;
    }

    @Input()
    set List(ls: any[]) {
        this.dropdownList = ls;
        this.prepareDropdown();
    }

    @Input()
    set RxSelectId(id: any) {
        this.rxID = id;
        this.prepareDropdown();
    }

    @Input()
    set BindLabel(hm: string) {
        this.bindLabel = hm;
        this.prepareDropdown();
    }

    @Input()
    set BindValue(hm: string) {
        this.bindValue = hm === 'null' ? undefined : hm;
    }

    @Input()
    set BindLabel2(hm: string) {
        this.bindLabel2 = hm;
    }

    @Input()
    set LabelForId(hm: string) {
        this.labelForId = hm;
    }

    @Input()
    set HasMultiple(hm: boolean) {
        this.hasMultiple = hm;
    }
    @Input()
    set HasBindLabel2(hb: boolean) {
        this.hasBindLabel2 = hb;
    }
    @Input()
    set HasControl(hc: boolean) {
        this.hasControl = hc;
    }

    @Input()
    set IsRequired(ir: boolean) {
        this.isRequired = ir;
    }
    @Input()
    set Show2Values(ir: boolean) {
        this.show2values = ir;
    }
    @Input()
    set ShowLabel2(ir: boolean) {
        this.showlabel2 = ir;
    }
    @Input()
    set Title(title: string) {
        this.titleText = title;
    }

    @Input()
    set FormGroupInvalid(hc: boolean) {
        this.hasFGInvalid = hc;
        if (this.hasFGInvalid) {
            this.validateAllFormFields(
                this.inputFormGroup,
                this.custContrlName
            );
        }
    }

    @Input()
    set TabIndex(ti: number) {
        this.tabIndex = ti;
    }

    @Input()
    set AutoFocus(ti: boolean) {
        this.autoFocus = ti;
    }

    @Input()
    set MarkAsTouched(mt: boolean) {
        if (mt) {
            this.validateAllFormFields(
                this.inputFormGroup,
                this.custContrlName
            );
        }
    }

    @Input()
    set InputValue(iv: any) {
        this.inputValue = iv;
    }

    @Input()
    set IsInputElemHidden(id: any) {
        this.isInputElemHidden = id;
    }

    @Input() secondCntrlN: string;
    @Input() scndFormGroupN: FormGroup;
    @Input() bindScnCntrlV: string;
    @Input() nextElement: string;
    @Input() changeText: boolean;
    @Input() IsAppendTo: boolean;
    
    private _isFromAccSetDisabled: boolean;
    @Input()
    set IsFromAccSetDisabled(value: boolean) {
        this._isFromAccSetDisabled = value;
        this.prepareDropdown();
    }
    get IsFromAccSetDisabled(): boolean {
        return this._isFromAccSetDisabled;
    }


    // @Output() TriggerChangeValue = new EventEmitter();
    @Output()
    TriggerSelectValue = new EventEmitter<{ value: string }>();
    @Output()
    AddSelectedValue = new EventEmitter<string>();

    @Output()
    TriggerOnBlur = new EventEmitter<string>();

    @Output()
    TriggerOnEnterValue = new EventEmitter<{ value: string }>();

    @Output()
    TriggerOnShiftTabbing = new EventEmitter<any>();

    @Output()
    TriggerOnTabbing = new EventEmitter<any>();

    @Output()
    TriggerOnFocus = new EventEmitter<any>();

    labelText: string;
    placeHolder: string;
    inputErrors: any;
    errorDefs: any;
    errorMessage: string;
    inputFormGroup: FormGroup;
    custContrlName: string;
    isDisabled = false;
    dropdownList: any[];
    hasMultiple = false;
    bindLabel: string;
    bindValue: string;
    bindLabel2: string;
    labelForId: string;
    hasControl = true;
    isRequired: boolean;
    hasBindLabel2: boolean;
    show2values: boolean;
    showlabel2: boolean;
    titleText: string;
    tabIndex: number;
    inputValue: any;
    rxID: any;
    isInputElemHidden = false;
    isTouched = false;
    processedDropdownList: any[] = [];

    constructor(private _validFormFieldsUtils: ValidateFormFieldsUtils, private cd: ChangeDetectorRef, private _element: ElementRef) {}

    ngOnInit() {
        // if (document.getElementById("rxdaw")) {
        //     document.getElementById("rxdaw").focus();
        // }
    }

    private prepareDropdown() {

        if (!this.dropdownList) {
            this.processedDropdownList = [];
            return;
        }

        const shouldCheck =
            this.rxID === 'rxRxOriginId' || this.IsFromAccSetDisabled;

        if (!this.bindLabel) {
            this.processedDropdownList = this.dropdownList;
            return;
        }

        this.processedDropdownList = this.dropdownList.map(item => {

            const isElectronic =
            item?.[this.bindLabel]?.toUpperCase() === 'ELECTRONIC';

            if (shouldCheck && isElectronic) {
            return { ...item, disabled: true };
            }

            return item;
        });
    }

    // ngOnChanges(changes: any): void {
    //     if (changes && changes.InputErrors) {
    //         const errors: any = changes.InputErrors.currentValue;
    //         this.errorMessage = "";
    //         if (errors) {
    //             Object.keys(this.errorDefs).some(key => {
    //                 if (errors[key]) {
    //                     this.errorMessage = this.errorDefs[key];
    //                     return true;
    //                 }
    //             });
    //         }
    //     }
    // }

    triggerChange($event) {
        this.TriggerSelectValue.emit({ value: $event });
        if (this.secondCntrlN) {
            const FG = this.scndFormGroupN ? this.scndFormGroupN : this.inputFormGroup;
            // ng-select (change) event passes the selected item directly, not a DOM event
            FG.controls[this.secondCntrlN].patchValue($event ? $event[this.bindScnCntrlV] : null);
        }
        if (this.hasControl) {
            this.validateAllFormFields(
                this.inputFormGroup,
                this.custContrlName
            );
        }
    }

    validateAllFormFields(formGroup?: FormGroup, formCntrl?: string) {
        if (this.hasControl) {
            this.errorMessage = this._validFormFieldsUtils.validateFormFields(
                formGroup,
                formCntrl,
                this.errorDefs
            );
        }
    }

    addSelectedValue($event) {
        this.AddSelectedValue.emit($event);
    }

    triggerOnBlur(value?: any): void {
        this.TriggerOnBlur.emit();
    }

    onEnter(event?: any): void {
        if (event.key === "Enter") {
            this.TriggerOnEnterValue.emit(event);
        }
    }

    setInputElemHidden() {
        this.isInputElemHidden = !this.isInputElemHidden;
        this.isTouched = true;
    }

    setIsTouchedFalse() {
        this.isInputElemHidden = !this.isInputElemHidden;
        this.isTouched = false;
    }

    ngAfterViewInit() {
        this.cd.detectChanges();
        
        // Manually focus the ng-select if autoFocus is true
        // This provides a fallback if appAutofocus directive doesn't work
        if (this.autoFocus && this.rxNgSelect) {
            setTimeout(() => {
                if (this.rxNgSelect && this.rxNgSelect.element) {
                    const inputElement = this.rxNgSelect.element.getElementsByTagName('input')[0];
                    if (inputElement) {
                        inputElement.focus();
                    }
                }
            }, 100);
        }
    }

    onShiftTabbingEvent(event) {
        if (event.shiftKey && event.key === "Tab") {
            this.TriggerOnShiftTabbing.emit(event);
        }
    }

    focusOnInput() {
        this.TriggerOnFocus.emit();
    }

    getWidth() {
        this.cd.detectChanges();
        if (this.IsAppendTo) {
            const selectElement = this._element.nativeElement.querySelector('.ng-select');
            if (selectElement) {
            const dropdownPanels = document.querySelectorAll('body > .ng-dropdown-panel');  
                // Check if panel is inside ng-select (appendTo not working)
                const inlinePanel = selectElement.querySelector('ng-dropdown-panel');
                if (inlinePanel) {
                    return;
                }
                if (dropdownPanels.length) {
                    const lastPanel = dropdownPanels[dropdownPanels.length - 1] as HTMLElement;
                    if (this.rxID && typeof this.rxID === 'string' && this.rxID.toLowerCase().includes('daw')) {
                        lastPanel.classList.add('daw-dropdown-panel');
                    }
                }
            }
            this.setAppendedDropdownWidth();
        }
    }

    setAppendedDropdownWidth() {
        // Set width for dropdowns appended to body
        if (!this.IsAppendTo) {
            return;
        }

        let attempts = 0;
        const maxAttempts = 20;
        
        const trySetWidth = () => {
            const selectElement = this._element.nativeElement.querySelector('.ng-select');
            
            if (selectElement) {
                // Find all dropdown panels in the body
                const dropdownPanels = document.querySelectorAll('body > .ng-dropdown-panel');
                
                // Check if panel is inside ng-select (appendTo not working)
                const inlinePanel = selectElement.querySelector('ng-dropdown-panel');
                if (inlinePanel) {
                    return;
                }
                
                if (dropdownPanels.length) {
                    const selectWidth = selectElement.offsetWidth;
                    // Find the most recently opened dropdown panel (last one)
                    const lastPanel = dropdownPanels[dropdownPanels.length - 1] as HTMLElement;
                    
                    if (lastPanel && lastPanel.style.display !== 'none' && !lastPanel.classList.contains('appended-to-body')) {
                        // Add marker class
                        lastPanel.classList.add('appended-to-body');
                        lastPanel.classList.add('rx-select-custom');
                        
                        // Set dynamic width
                        // lastPanel.style.minWidth = `${selectWidth}px`;
                        // lastPanel.style.maxWidth = 'min(calc(100vw - 120px), 350px)';
                        // lastPanel.style.width = 'max-content';
                    }
                } else {
                    // Retry if panel not found yet
                    attempts++;
                    if (attempts < maxAttempts) {
                        setTimeout(trySetWidth, 50);
                    }
                }
            }
        };
        
        setTimeout(trySetWidth, 100);
    }

    focusonTab(event?: any){
        // Validate the form field first
        this.validateAllFormFields(this.inputFormGroup, this.custContrlName);
        
        // If invalid, prevent tab and refocus
        if (this.hasControl && this.inputFormGroup && this.inputFormGroup.controls && 
            this.inputFormGroup.controls[this.custContrlName] && 
            this.inputFormGroup.controls[this.custContrlName].invalid) {
            event?.preventDefault();
            let input = this._element.nativeElement.getElementsByTagName("input");
            if (input && input.length) {
                input[0].focus();
            }
        }
        
        // Emit TriggerOnTabbing for parent component to handle navigation
        this.TriggerOnTabbing.emit(event);
        
        // If nextElement is specified, focus on it
        if(this.nextElement && document.getElementById(this.nextElement)){
            if(this.nextElement){
                const elem = document.getElementById(this.nextElement);
                let inputEle = elem.getElementsByTagName("input");
                if (inputEle && inputEle.length) {
                    inputEle[0].focus();
                } else {
                    document.getElementById(this.nextElement).focus();
                }
            } else {
                document.getElementById(this.nextElement).focus();
            }
        }
    }
}
